/** Default messages of the built-in validators. The module owns these keys; legacy `VALIDATION.*` keys are not reused. */
export const TRANSLATIONS = {
    EN: {
        FORMS: {
            VALIDATION: {
                REQUIRED: 'This field is required',
                EMAIL: 'Enter a valid email address',
                MIN: 'Enter {min} or more',
                MAX: 'Enter {max} or less',
                MIN_LENGTH: 'Enter at least {length} characters',
                MAX_LENGTH: 'Enter at most {length} characters',
                MIN_ITEMS: 'Add at least {length} items',
                MAX_ITEMS: 'Add at most {length} items',
                PATTERN: 'Enter a value in the expected format',
            },
        },
    },
    NL: {
        FORMS: {
            VALIDATION: {
                REQUIRED: 'Dit veld is verplicht',
                EMAIL: 'Vul een geldig e-mailadres in',
                MIN: 'Vul {min} of meer in',
                MAX: 'Vul {max} of minder in',
                MIN_LENGTH: 'Vul minimaal {length} tekens in',
                MAX_LENGTH: 'Vul maximaal {length} tekens in',
                MIN_ITEMS: 'Voeg minimaal {length} items toe',
                MAX_ITEMS: 'Voeg maximaal {length} items toe',
                PATTERN: 'Vul een waarde in het verwachte formaat in',
            },
        },
    },
};
